// Dependencies
import React, { Component } from 'react';

// Multi lang
import { withTranslation } from 'react-multi-lang';

// Redux
import { connect } from 'react-redux';
import { resetApp } from '../../redux/actions/app';
import { setUserParameters } from '../../redux/actions/authentication';
import { getAssociateData, getInternalAssociateData } from '../../redux/actions/profile';
import AuthenticationService from '../../redux/services/authentication';

// Utils
import { REGISTRATION_STATE_APPROVED, REGISTRATION_STATE_SUSPENDED } from '../../common/constants';

class AuthenticationProxyPage extends Component {

    constructor(props) {
        super(props);
        this.state = {

        };
    }

    componentDidMount() {
        
        this.props.resetApp();

        let userParameters = this.getProxyParameters();
    }

    getProxyParameters() {
        let search = window.location.search;
        let params = new URLSearchParams(search);

        if(this.validateProxyParameters(params)) {
            let queryParameter = params.get('q');
            let redirectParameter = params.get('redirect');
            let userParameters = window.atob(queryParameter).split(',');

            AuthenticationService.validateUserData(userParameters)
            .then((response) => {
                if(response.validationResult === true) {
                    this.props.setUserParameters(userParameters[0], userParameters[1], userParameters[2], response.registrationState === REGISTRATION_STATE_APPROVED, response.registrationState, response.mbPending, response.mbwayPending, response.organicUnits, response.brainAnswerAccess, response.hasSignatureCredits, response.internal);
                    if(response.internal) {
                        this.props.getInternalAssociateData(userParameters[0]);

                        setTimeout(() => window.open(process.env.PUBLIC_URL + "/allowances","_self"), 3000);
                    }
                    else {
                        this.props.getAssociateData(userParameters[2]);

                        if(response.registrationState === REGISTRATION_STATE_APPROVED) {
                            if(redirectParameter === null) {
                                setTimeout(() => window.open(process.env.PUBLIC_URL + "/dashboard","_self"), 3000);
                            }
                            else {
                                setTimeout(() => window.open(process.env.PUBLIC_URL + "/" + redirectParameter,"_self"), 3000);
                            }
                        }
                        else if (response.registrationState === REGISTRATION_STATE_SUSPENDED) {
                            setTimeout(() => window.open(process.env.PUBLIC_URL + "/suspension","_self"), 3000);
                        }
                        else {
                            setTimeout(() => window.open(process.env.PUBLIC_URL + "/finance","_self"), 3000);
                        }
                    }
                }
                else {
                    window.open(process.env.REACT_APP_OF_PORTAL_URL,"_self");
                }
            })
            .catch(error => {
                window.open(process.env.REACT_APP_OF_PORTAL_URL,"_self");
            });
        }
        else {
            window.open(process.env.REACT_APP_OF_PORTAL_URL,"_self");
        }
    }

    validateProxyParameters(params) {
        if(params === null) return false;

        let queryParameter = params.get('q');

        if(queryParameter === null || queryParameter === "") return false;

        let userParameters = window.atob(queryParameter).split(',');

        return (userParameters.length === 3);
    }

    render() {

        return (
            <div className="grid">
                <div className="col-1"></div>
                <div className="col-10">
                    <div className="card t-align-left mgt-30">
                        <h5>{this.props.t("authentication.title")}</h5>
                        <p>{this.props.t("authentication.message")}</p>
                    </div>
                </div>
                <div className="col-1"></div>
            </div>
        );
    }
}
  
const mapDispatchToProps = (dispatch) => {
    return {
        setUserParameters: (userId, formId, registrationRef, registrationApproved, registrationState, mbPending, mbwayPending, organicUnit, brainAnswerAccess, hasSignatureCredits, internal) => { dispatch(setUserParameters(userId, formId, registrationRef, registrationApproved, registrationState, mbPending, mbwayPending, organicUnit, brainAnswerAccess, hasSignatureCredits, internal)) },
        getAssociateData: (registrationRef) => { dispatch(getAssociateData(registrationRef)) },
        getInternalAssociateData: (userRef) => { dispatch(getInternalAssociateData(userRef)) },
        resetApp: () => { dispatch(resetApp()) },
    }
};

export default connect(undefined, mapDispatchToProps)(withTranslation(AuthenticationProxyPage));